import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { VerificacionObraService } from 'src/app/datos/verificacion-obra.service';
import { HttpSession, Util } from 'src/app/libs/ruvpp-angular2-comun/index';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { EcotecnologiaDTO, InputReporte, OutputReporteEcotecnologia, OutputVistaInformacionGeneral, SeguridadSalida, ViviendaDTO, Atributos, InputReporteEcotecnologia } from 'src/app/modelo';

//@Autor: Ernesto López Hdez
@Component({
    selector: 'app-ecotecnologias-atributos',
    templateUrl: './ecotecnologias-atributos.component.html',
    //styleUrls: ['./ecotecnologias-atributos.component.css']
})
export class EcotecnologiasAtributosComponent implements OnInit {

    public user: SeguridadSalida;
    public usuario: string;
    public verificador: string;

    //Forma

    public ecotecnologia: OutputReporteEcotecnologia;
    public entity: ViviendaDTO;
    public vistaInformacionGeneral: OutputVistaInformacionGeneral;
    public btn_Disabled: boolean;

    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     * @param spinner
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: VerificacionObraService, private _router: Router, private spinner: NgxSpinnerService) {

        this.user = HttpSession.getAttribute('USER');

        if (this.user != null) {
            this.usuario = `${HttpSession.getAttribute('USER_NAME')}`;
            this.verificador = `${HttpSession.getAttribute('USER_VERIFICADOR')}`;
        }

        this.vistaInformacionGeneral = HttpSession.getAttribute('ENTITY');

        console.log('EcotecnologiasAtributosComponent -->> ', new Date());

    }

    /**
     * 
     */
    public async ngOnInit() {
        this.entity = <ViviendaDTO>{};
        this.ecotecnologia = <OutputReporteEcotecnologia>{ listaViviendas: [] };
    }

    /**
     * 
     */
    public async init() {
        await this.loading();
    }

    /**
     * 
     */
    public async loading() {

        this.btn_Disabled = true;

        this.entity = <ViviendaDTO>{};

        this.ecotecnologia = <OutputReporteEcotecnologia>{ listaViviendas: [] };

        let dato: InputReporte = <InputReporte>{ idOrdenVerificacion: this.vistaInformacionGeneral.ordenVerificacion };

        let resultado: JsonResponse<OutputReporteEcotecnologia> = await this.service.ObtenerReporteEcotecnologia(dato).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            this.ecotecnologia = resultado.model;

            if (this.ecotecnologia.listaViviendas != null && this.ecotecnologia.listaViviendas.length > 0) {

                this.entity = this.ecotecnologia.listaViviendas[0];

                //this.entity.claveEstatus = 0;

                for (let vivienda of this.ecotecnologia.listaViviendas) {

                    for (let atributo of vivienda.listAtributos) {
                        atributo.cumple_TMPS = atributo.cumple;
                        atributo.actualizado = false;
                    }

                    for (let ecotecnologia of vivienda.listaEcotecnologia) {
                        ecotecnologia.cumpleEcotecnologia_TMPS = ecotecnologia.cumpleEcotecnologia;
                        ecotecnologia.actualizado = false;
                    }

                }

                this.btn_Disabled = false;

                this.validacionVerEcotecnologiasAtributos();

                this.setIconVivienda();

                this.setClaveEstatusDescripcion();

                if (this.entity.claveEstatus != 0) {
                    Util.showMessage(this.servicioAlertas, 'Verificación de Obra', `El estatus de la vivienda es :  <span style="color:red">${this.entity.claveEstatusDescripcion}</span>`, 'warning', true);
                }

            }

        } else {
            console.error(`---------------------------------------------------------------------------------------------------------------------`);
            console.error(`Error: `, resultado);
        }
    }

    /**
    * 
    * @param entity
    */
    public onRowSelect(entity: ViviendaDTO): void {

        let object: ViviendaDTO = this.ecotecnologia.listaViviendas.filter(row => row.indentificadorVivienda == entity.indentificadorVivienda)[0];

        this.entity = object;

        this.setClaveEstatusDescripcion();

        this.validacionVerEcotecnologiasAtributos();
    }

    /**
     * 
     * @param entity
     */
    public onRowUnselect(entity: any): void {

    }

    /**
   * 
   * @param entity
   */
    public onRowSelectEcotecnologia(entity: any): void {

    }

    /**
     * 
     * @param entity
     */
    public onRowUnselectEcotecnologia(entity: any): void {

    }

    /**
     * 
     */
    private validacionVerEcotecnologiasAtributos(): void {

        if (this.entity.esAmpliada == null && this.entity.esEcotecnologia == null && this.entity.esAtributo == null) {
            this.entity.esEcotecnologia = 1;
            this.entity.esAtributo = 1;
        } else { 
            if (this.entity.esAmpliada == 1) {
                this.entity.esEcotecnologia = 1;
                this.entity.esAtributo = 1;
            } 
        }

        this.btn_Disabled = true;

        if (this.entity.esAtributo == 1 || this.entity.esEcotecnologia == 1) {
            this.btn_Disabled = false;
        }

    }

    /**
    * 
    */
    public Regresar(): void {
        Util.forward(this._router, 'VistaInformacionGeneralComponent');
    }

    /**
     * 
     */
    private setClaveEstatusDescripcion(): void {
        switch (this.entity.claveEstatus) {
            case 0: this.entity.claveEstatusDescripcion = 'Disponible'; break;
            case 1: this.entity.claveEstatusDescripcion = 'Crédito solicitado'; break;
            case 3: this.entity.claveEstatusDescripcion = 'Individualizada'; break;
            case 4: this.entity.claveEstatusDescripcion = 'Cancelada'; break;
        }
    }

    /**
     * 
     */
    private setIconVivienda(): void {

        if (this.ecotecnologia != null && this.ecotecnologia.listaViviendas != null) {

            for (let vivienda of this.ecotecnologia.listaViviendas) {

                let estatus: number | null = null;
                let cumple: number = 0;
                let noCumple: number = 0;
                let sinCalificar: number = 0;

                let contador: number = vivienda.listAtributos.length + vivienda.listaEcotecnologia.length;

                for (let atributo of vivienda.listAtributos) {

                    if (atributo.cumple == 1) {
                        cumple++;
                    } else {

                        if (atributo.cumple == 0) {
                            noCumple++;
                        } else {
                            sinCalificar++;
                        }
                    }
                }

                for (let ecotecnologia of vivienda.listaEcotecnologia) {

                    if (ecotecnologia.cumpleEcotecnologia == '1') {
                        cumple++;
                    } else {

                        if (ecotecnologia.cumpleEcotecnologia == '0') {
                            noCumple++;
                        } else {
                            sinCalificar++;
                        }
                    }

                }

                if (contador > 0 && contador == cumple) {
                    estatus = 1;
                } else {

                    if (noCumple > 0) {
                        estatus = 0;
                    }

                }

                vivienda.estatus = estatus;
            }

        }

    }

    /**
    * 
    */
    public async Guardar() {

        let inputReporteEcotecnologia: InputReporteEcotecnologia = <InputReporteEcotecnologia>{};

        let listaViviendas: ViviendaDTO[] = [];

        for (let viviendas of this.ecotecnologia.listaViviendas) {

            let listAtributos: Atributos[] = viviendas.listAtributos.filter(row => row.actualizado == true);

            for (let row of listAtributos) {
                row.cumple = row.cumple_TMPS;
            }

            let listEcotecnologias: EcotecnologiaDTO[] = viviendas.listaEcotecnologia.filter(row => row.actualizado == true);

            for (let row of listEcotecnologias) {
                row.cumpleEcotecnologia = row.cumpleEcotecnologia_TMPS;
            }

            let vivienda: ViviendaDTO = Util.clone(viviendas);

            vivienda.listAtributos = listAtributos;

            vivienda.listaEcotecnologia = listEcotecnologias;

            if (vivienda.listAtributos.length > 0 || vivienda.listaEcotecnologia.length > 0) {
                listaViviendas.push(vivienda);
            }

        }

        inputReporteEcotecnologia.listaViviendas = listaViviendas;

        inputReporteEcotecnologia.ordenVerificacion = this.ecotecnologia.ordenVerificacion;

        if (listaViviendas != null && listaViviendas.length > 0) {

            Util.showLoadingMessage(this.spinner, `Guardando información de reporte de ecotecnologías y atributos ...`);

            let resultado: JsonResponse<boolean> = await this.service.GuardarReporteEcotecnologia(inputReporteEcotecnologia).toPromise();

            Util.hideLoadingMessage();

            if (resultado != null && resultado.code == 200 && resultado.model != null) {

                let respuesta: boolean = resultado.model;

                if (respuesta == true) {

                    var strCallback = (): void => {
                        this.Regresar();
                    }

                    let value = Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Información guardada correctamente ...', 'success', false, strCallback);

                } else {
                    Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Error al intentar guardar la información ...', 'warning');
                }

            }
        } else {
            Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Para enviar a guardar la información, se necesita realizar una calificación [Atributo, Ecotecnología]...', 'warning');
        }


    }

    /**
     * 
     * @param entity
     * @param value
     */
    public onChangeCumplimientoAtributos(entity: Atributos, value: number) {
        entity.actualizado = true;
        entity.cumple_TMPS = value;
    }

    /**
     * 
     * @param entity
     * @param value
     */
    public onChangeCumplimientoeEcotecnologia(entity: EcotecnologiaDTO, value: number) {
        entity.actualizado = true;
        entity.cumpleEcotecnologia_TMPS = value.toString();
    }

    /**
     * 
     * @param entity
     */
    public getDisabledAtributos(entity: Atributos): boolean {

        let resultado: boolean = false;

        if (this.entity.claveEstatus == 0) {

            if (entity.cumple == 1) {
                resultado = true;
            } else {

                if (entity.calificable == true) {

                    if (entity.calificableEnFuncion == 1) {

                        if (entity.valorFuncionamiento == 4 || entity.valorFuncionamiento == 5) {
                            resultado = true;
                        } else {
                            resultado = false;
                        }


                    } else {
                        resultado = false;
                    }


                } else {
                    resultado = true;
                }
            }


        } else {
            resultado = true;
        }

        return resultado;
    }

    /**
     * 
     * @param entity
     */
    public getDisabledEcotecnologias(entity: EcotecnologiaDTO): boolean {

        let resultado: boolean = false;

        if (this.entity.claveEstatus != 0) {
            resultado = true;
        }

        if (entity != null && entity.cumpleEcotecnologia == '1') {
            resultado = true;
        }

        return resultado;
    }

}
